import React from 'react';
import Text from 'components/Text/Text';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './NoItemsNotification.module.scss';

interface IProps {
	onClickShowAssignModal: () => void;
	title: string;
	description: string;
	assignBtnTranslationKey: string;
	iconId?: 'plus' | 'pencil';
}

export const NoItemsNotification: React.FC<IProps> = React.memo(
	({ onClickShowAssignModal, title, description, assignBtnTranslationKey, iconId = 'plus' }) => {
		return (
			<>
				<Text size="s" translationNameSpace="form" translationKey={title} />
				<FullInfoField containerClassName={style.marginTopZero} label={description} />
				<Button
					className={style.editBtn}
					size="sizeS"
					theme="outlined"
					onClick={onClickShowAssignModal}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#${iconId}`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey={assignBtnTranslationKey} asFragment={true} />
				</Button>
			</>
		);
	},
);
